import type { Operation } from '@apollo/client/link/core/types';
import type { GraphQLError, GraphQLFormattedError } from 'graphql/error/GraphQLError';
import type {
  ServerError,
  ServerParseError,
} from '@apollo/client';

import {
  AUTH_ERROR_MESSAGE,
  AUTH_ERROR_MESSAGE_LEGACY,
} from '@constants';

// Error is used to represent graphql errors in Sentry
export class SentryGraphQLError extends Error {
  constructor(operation: Operation, errors: readonly GraphQLFormattedError[]) {
    const message = (
      `Operation: ${operation.operationName};\n`
      + 'Messages:\n'
      + `${errors.map((err) => err.message).join('\n')}`
    );
    super(message);
    this.name = 'GraphQLError';
  }
}

// Error is used to represent network errors in Sentry
export class SentryNetworkError extends Error {
  constructor(operation: Operation, networkError: Error | ServerError | ServerParseError) {
    const message = (
       
      `Operation: ${operation.operationName};\nMessage: ${networkError}`
    );
    super(message);
    this.name = 'NetworkError';
  }
}

export const isAuthError = (err: GraphQLError) => (
  err.message === AUTH_ERROR_MESSAGE
  || err.message === AUTH_ERROR_MESSAGE_LEGACY
);
